import controller from './wf-editor-home.controller';
import template from './wf-editor-home.html';

export default {
	controller,
	template,
	bindings: {
		adminWf: '<',
	},
};
